import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class ParametrosServicioService {

  constructor(private http: HttpClient) { }

  private API_TIPO_SERVICIO = environment.API_BASE + '/Services/Params';

  getParams(): Observable<string[]> {
    return this.http.get<string[]>(this.API_TIPO_SERVICIO);
  }
}
